import React, { useEffect, useState } from 'react';
import "./style.scss";
import SingleSlideSlider from '../../../core/components/singleSlideSlider';
import TimerIcon from '../../../icons/TimerIcon';
import BusinessIcon from '../../../icons/BusinessIcon';
import CalendarIcon from '../../../icons/CalendarIcon';
import GroupUsersIcon from '../../../icons/GroupUsersIcon';
import { Link, useNavigate, useParams } from 'react-router-dom';
import EditGreyIcon from '../../../icons/EditGreyIcon';
import { deleteClassById, getClassDetails, pauseClass } from '../../../services/classes.service';
import moment from 'moment';
import AutoTurnOnModal from '../../../core/components/pauseClass/PauseClass';
import { toast } from 'react-toastify';
import ArrowLeftIcon from '../../../icons/ArrowLeftIcon';
import { Button, Modal } from 'react-bootstrap';
import DeleteRedIcon from '../../../icons/DeleteRedIcon';
import { AxiosError } from 'axios';
import DeleteGreyIcon from '../../../icons/DeleteGreyIcon';

export default function DetailClass() {
  const navigate = useNavigate();
  const [isToggled, setIsToggled] = useState(false);
  const [isClassPaused, setClassPaused] = useState(false);
  const { id } = useParams() || '';
  const [classDetails, setClassDetails] = useState<any>({});
  const [startTimeFormat, setStartTimeFormat] = useState<string>('');
  const [endTimeFormat, setEndTimeFormat] = useState<string>('');
  const [selectedClassId, setSelectedClassId] = useState<string | null>(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  const handleToggle = () => {
    if (isClassPaused) {
      resetClass();
    } else {
      setIsToggled(!isToggled);
    }
  };

  const resetClass = async () => {
    let obj: any = {
      type: "none",
      date: null
    }
    const result = await pauseClass(id, { classPause: obj })
    if (result.data) {
      toast.success("Classes Updated successfully");
      handleCloseModal()
    }
  }
  const handleCloseModal = () => {
    getClasseDetails(id);
    setIsToggled(false)
  };
  useEffect(() => {
    getClasseDetails(id);
  }, [isToggled]);

  const calculateTimeFormat = (value: any) => {
    return value ? moment(value, 'HH:mm').format('A') : null
  }
  const getRepeatInfo = (classData: any) => {
    let string = "Once";
    if (
      classData?.classRepeat?.type == "repeat" &&
      classData?.classRepeat?.selection
    ) {
      if (classData?.classRepeat?.selection == "week") {
        string = "Weekly";
      }
      if (classData?.classRepeat?.selection == "day") {
        string = "Daily";
      }
      if (classData?.classRepeat?.selection == "month") {
        string = "Monthly";
      }
    }
    return string;
  };

  const calculateClassTimings = (classData: any) => {
    let string = ''
    let frequency = "Once"
    if (
      classData?.classRepeat?.type == "repeat" &&
      classData?.classRepeat?.selection
    ) {
      if (classData?.classRepeat?.selection == "week") {
        frequency = "Weekly";
      }
      if (classData?.classRepeat?.selection == "day") {
        frequency = "Daily";
      }
      if (classData?.classRepeat?.selection == "month") {
        frequency = "Monthly";
      }
    }
    string = ` ${frequency} | ${moment(classData?.classTime?.date).format("DD-MM-YYYY")} | ${classDetails?.classTime?.start} ${calculateTimeFormat(classDetails?.classTime?.start)} - ${classDetails?.classTime?.end} ${calculateTimeFormat(classDetails?.classTime?.end)}`
    return string
  }

  const getClasseDetails = async (id: any) => {
    try {
      const result = await getClassDetails(id);
      setClassDetails(result?.data?.data || {});
      if (result?.data?.data?.classPause?.type && result?.data?.data?.classPause?.type != "none") {
        setClassPaused(true)
      }
      else {
        setClassPaused(false)
      }
      // Get AM or PM
      const amOrPmMorning = moment(result?.data?.data?.startTime, 'HH:mm').format('A');
      const amOrPmEvening = moment(result?.data?.data?.endTime, 'HH:mm').format('A');
      setStartTimeFormat(amOrPmMorning)
      setEndTimeFormat(amOrPmEvening)
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteClass = async (id: string) => {
    if (!id) return;
    setSelectedClassId(id)
    setDeleteModalShow(true);
  }

  const handleDeleteClose = () => {
    setDeleteModalShow(false);
  };

  const handleDeleteConfirm = async (selectedClassId: string | null) => {
    if (!selectedClassId) return;
    try {
      const result = await deleteClassById(selectedClassId);

      if (result?.data?.responseCode === 404) {
        toast.error(result?.data?.responseMessage)
      }
      else {
        toast.success(result?.data?.responseMessage);
      }
      setDeleteModalShow(false);
      navigate("/classes");
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.responseMessage)
      }
    }
  }


  return (
    <div className="classDetail">
      <div className="container">
        <Link className='back_btn' to={'/classes'}><ArrowLeftIcon /></Link>
        {classDetails?.images && classDetails?.images.length > 0 && (
          <div className="sliderWrap mt-3">
            <div className="singleSlideSlider">
              <SingleSlideSlider imageList={classDetails?.images} />
            </div>
          </div>
        )}
        <div className="classTop mt-4 d-flex justify-content-between align-items-start">
          <div className="classLeftSide">
            <span>
              <BusinessIcon />
              {classDetails?.partnerDetails?.businessName}
            </span>
            <h2 className="my-3">{classDetails?.className}</h2>
            <ul>
              <li>
                <CalendarIcon />
                {getRepeatInfo(classDetails)}
              </li>
              <li>
                <GroupUsersIcon />
                {classDetails?.maxBooking || 0}
              </li>
            </ul>
          </div>

          <div className="classRightSide">
            <div className="row">
              <div className="col">
                <div className="toggle-container pt-2">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={!isClassPaused}
                      onChange={handleToggle}
                    />
                    <span className="slider"></span>

                  </label>
                  <span className="label p-1">
                    {isClassPaused ? "Paused" : "On"}
                  </span>
                </div>
              </div>
              <div className="col">
                <Link to={`/classes/edit/${classDetails._id}`}>
                  <EditGreyIcon />
                  {" "}
                  Edit class
                </Link>
              </div>
              <div className="col">
                <button
                  className='deleteClass'
                  onClick={() => handleDeleteClass(classDetails._id)}
                >
                  <DeleteGreyIcon />
                  {" "}
                  Delete class
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="aboutContent">
          <h3>About {classDetails?.className}</h3>
          <p className="mb-0">{classDetails?.description}</p>
        </div>
        <div className="timingContent">
          <h3>Class timing</h3>
          <ul>
            <li>
              <TimerIcon />
              <span>{calculateClassTimings(classDetails)}</span>
            </li>
          </ul>
        </div>
      </div>
      {isToggled && (
        <AutoTurnOnModal
          show={isToggled}
          handleClose={handleCloseModal}
          id={id}
          classDetails={classDetails}
        />
      )}

      {/* Delete Confirmation Modal */}
      <Modal show={deleteModalShow} onHide={handleDeleteClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className='delete-modal'
      >
        <Modal.Body className='text-center'>
          <div className='d-flex justify-content-center align-items-center'>
            <DeleteRedIcon />
          </div>
          <h3>Confirm Deletion</h3>
          <p>Are you sure you want to delete this class? This action cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline" onClick={handleDeleteClose}>Close</Button>
          <Button className='primaryButton' variant="primary" onClick={() => handleDeleteConfirm(selectedClassId)}>Continue</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
